// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "a.summary-bar-all-categories[data-v-68a4ed48]{align-items:center;background:none;border-radius:0;display:flex;height:100%;margin-right:.5em;padding:0}.summary-bar-all-categories[data-v-68a4ed48] img{filter:none;height:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
